import { ArrowRightIcon, SparklesIcon } from "@heroicons/react/24/outline";
import { HERO_STATS } from "./landing-data";

function DashboardPreview() {
  return (
    <div
      className="relative mx-auto w-full max-w-lg lg:max-w-none"
      aria-hidden
    >
      <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-sky-500/30 via-indigo-500/20 to-transparent blur-2xl" />
      <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-slate-900/90 shadow-2xl shadow-black/40 ring-1 ring-white/10">
        <div className="flex items-center gap-2 border-b border-white/10 bg-slate-950/80 px-4 py-3">
          <span className="h-2.5 w-2.5 rounded-full bg-rose-400/80" />
          <span className="h-2.5 w-2.5 rounded-full bg-amber-400/80" />
          <span className="h-2.5 w-2.5 rounded-full bg-emerald-400/80" />
          <span className="ml-2 font-mono text-xs text-slate-500">
            promang.no/dashboard
          </span>
        </div>
        <div className="grid gap-3 p-4 sm:grid-cols-2 sm:p-5">
          <div className="rounded-xl border border-white/5 bg-slate-800/60 p-4">
            <p className="text-xs font-medium uppercase tracking-wider text-sky-400">
              Aktive prosjekter
            </p>
            <p className="mt-2 text-3xl font-bold text-white">
              24
            </p>
            <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-slate-700">
              <div className="h-full w-4/5 rounded-full bg-gradient-to-r from-sky-400 to-indigo-500" />
            </div>
          </div>
          <div className="rounded-xl border border-white/5 bg-slate-800/60 p-4">
            <p className="text-xs font-medium uppercase tracking-wider text-emerald-400">
              Service denne uken
            </p>
            <p className="mt-2 text-3xl font-bold text-white">
              18
            </p>
            <p className="mt-2 text-xs text-slate-400">12 fullført · 6 planlagt</p>
          </div>
          <div className="col-span-1 rounded-xl border border-white/5 bg-slate-800/40 p-4 sm:col-span-2">
            <p className="mb-3 text-xs font-medium text-slate-400">
              Siste aktivitet
            </p>
            <ul className="space-y-2">
              {[
                "Rapport signert — Ventilasjon Åsane",
                "Avvik lukket — Kjølebatteri",
                "Timeliste godkjent — Prosjekt Nord",
              ].map((line) => (
                <li
                  key={line}
                  className="flex items-center gap-2 text-sm text-slate-300"
                >
                  <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-sky-400" />
                  {line}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export function LandingHero() {
  return (
    <section className="relative overflow-hidden bg-slate-950 pb-20 pt-12 sm:pb-28 sm:pt-16 lg:pb-32">
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(56,189,248,0.18),transparent)]"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute right-0 top-0 h-[500px] w-[500px] translate-x-1/3 -translate-y-1/4 rounded-full bg-indigo-600/10 blur-3xl"
        aria-hidden
      />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:items-center lg:gap-16">
          <div className="text-center lg:text-left">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-sky-500/30 bg-sky-500/10 px-4 py-1.5 text-sm text-sky-200">
              <SparklesIcon className="h-4 w-4 text-sky-400" aria-hidden />
              Driftsystem for moderne servicebedrifter
            </div>

            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
              <span className="block">Alt arbeidet deres</span>
              <span className="mt-1 block bg-gradient-to-r from-sky-300 via-sky-400 to-indigo-400 bg-clip-text text-transparent">
                samlet i Promang
              </span>
            </h1>

            <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-slate-400 lg:mx-0">
              Prosjektstyring, service, kvalitet, dokumentasjon og økonomi i én
              plattform — skreddersydd for bedrifter som leverer i felt og på
              kontoret.
            </p>

            <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row lg:justify-start">
              <a
                href="/authentication/login"
                className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-sky-500 px-8 py-3.5 text-base font-semibold text-white shadow-lg shadow-sky-500/30 transition hover:bg-sky-400 sm:w-auto"
              >
                Logg inn
                <ArrowRightIcon className="h-5 w-5" aria-hidden />
              </a>
              <a
                href="#funksjoner"
                className="inline-flex w-full items-center justify-center rounded-xl border border-white/15 bg-white/5 px-8 py-3.5 text-base font-medium text-slate-200 transition hover:bg-white/10 sm:w-auto"
              >
                Se funksjoner
              </a>
            </div>

            <dl className="mt-14 grid grid-cols-1 gap-6 border-t border-white/10 pt-10 sm:grid-cols-3">
              {HERO_STATS.map((stat) => (
                <div key={stat.label} className="text-center lg:text-left">
                  <dt className="text-lg font-semibold text-white">
                    {stat.value}
                  </dt>
                  <dd className="mt-1 text-sm text-slate-500">{stat.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="mt-16 lg:mt-0">
            <DashboardPreview />
          </div>
        </div>
      </div>
    </section>
  );
}
